import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../common';
import { IPermission, IRole } from '../models';
import { IRolePermission } from '../models/i-role-permission';
import { ApiResponse, BaseResponse } from '../models/responses';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(private http: HttpClient) { }

  GetPermissions(){
    return this.http.get<ApiResponse<IPermission[]>>(`${Constants.API_URL}api/Permission/GetPermissions`);
  }

  GetPermissionsByRole(Role: IRole){
    return this.http.get<ApiResponse<IRolePermission[]>>(`${Constants.API_URL}api/Permission/GetPermissionsByRole?RoleId=${Role.Id}`);
  }

  UpdatePermissionsByRole(PermissionIds: number[], RoleId: number){
    let params = {
      PermissionsIds: PermissionIds,
      RoleId: RoleId
    }
    return this.http.post<ApiResponse<IRolePermission[]>>(`${Constants.API_URL}api/Permission/UpdatePermissionsByRole`, params);
  }
  
  GetPermissionsByUser(UserId: number): Observable<ApiResponse<IPermission[]>> {
    return this.http.get<ApiResponse<IPermission[]>>(
      `${Constants.API_URL}api/Permission/GetPermissionsByUser?UserId=${UserId}`)
  }
}
